import styled from 'styled-components';

export const LiveArenaWidgetDescriptionBox = styled.div<{smallFont: boolean}>`
    color: ${props => props.theme.components.partyJackpotInGameWidget.colors.amount};
    font-family: ${props => props.theme.font.family.ultra};
    font-size: ${props => props.smallFont? "9px": "20px"};
    text-align: center;
    margin-left: 1px;
    flex-shrink: 0;
`;
